import {useIntl} from 'react-intl';
import {AlertTriangle, VideoOff, Wifi} from 'lucide-react';
import {CallToast} from '../components/CallToast';
import {useReliefActions, useReliefView} from './videoReliefStore';
import {videoReliefMessages as m} from './videoReliefMessages';

export const VideoReliefToast = () => {
    const intl = useIntl();
    const view = useReliefView();
    const actions = useReliefActions();
    if (view.blocked) {
        return null;
    }
    if (view.phase === 'promptPause') {
        const cpu = view.reason === 'cpu';
        return (
            <CallToast
                testId="video-relief-pause"
                icon={cpu ? <AlertTriangle size={18} className="text-[var(--phq-call-warning-ink)]" aria-hidden="true"/> : <Wifi size={18} className="text-[var(--phq-call-warning-ink)]" aria-hidden="true"/>}
                lead={intl.formatMessage(cpu ? m.cpuLead : m.networkLead)}
                body={intl.formatMessage(m.body)}
                actionLabel={intl.formatMessage(m.pause)}
                actionTone="brand"
                onAction={actions.accept}
                secondaryLabel={intl.formatMessage(m.notNow)}
                onSecondary={actions.dismiss}
            />
        );
    }
    if (view.phase === 'promptResume') {
        return (
            <CallToast
                testId="video-relief-resume"
                icon={<Wifi size={18} className="text-[var(--phq-call-brand-focus)]" aria-hidden="true"/>}
                lead={intl.formatMessage(m.recoveredLead)}
                actionLabel={intl.formatMessage(m.resume)}
                actionTone="brand"
                onAction={actions.accept}
                secondaryLabel={intl.formatMessage(m.notNow)}
                onSecondary={actions.dismiss}
            />
        );
    }
    return null;
};

export const PausedVideoButton = ({compact = false}: {compact?: boolean}) => {
    const intl = useIntl();
    const actions = useReliefActions();
    const view = useReliefView();
    if (view.blocked) {
        return null;
    }
    return (
        <button
            type="button"
            data-testid="video-relief-paused"
            onClick={actions.resume}
            className={`phq-call-press inline-flex items-center gap-1.5 rounded-lg bg-[var(--phq-call-chip-scrim)] font-semibold ${compact ? 'h-6 px-2 text-xs' : 'h-7 px-2.5 text-[13px]'}`}
        >
            <VideoOff size={compact ? 12 : 14} className="text-[var(--phq-call-warning-ink)]" aria-hidden="true"/>
            <span className="truncate">{intl.formatMessage(m.paused)}</span>
        </button>
    );
};
